import { viperApi, clinicalApiPath } from '@/services/viper-api'
import * as qs from 'qs'

export const membershipService = {
  basePath: organizationId => `${clinicalApiPath}/organizations/${organizationId}/memberships`,

  get(organizationId, membershipId) {
    return viperApi.get(this.basePath(organizationId) + `/${membershipId}`)
  },

  list(organizationId, params) {
    return viperApi.get(this.basePath(organizationId), {
      params,
      paramsSerializer: function(params) {
        return qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' })
      }
    })
  },

  create(membership) {
    return viperApi.post(this.basePath(membership.organization.id), membership)
  },

  delete(organizationId, membershipId) {
    return viperApi.delete(this.basePath(organizationId) + `/${membershipId}`)
  },

  update(organizationId, userRolesRequest) {
    return viperApi.put(this.basePath(organizationId), userRolesRequest)
  }
}
